var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C19.9995 7.348 18.9457 4.80477 17.0705 2.92952C15.1952 1.05427 12.652 0.000530241 10 0V2C11.5821 2.00036 13.1286 2.46964 14.4441 3.34854C15.7596 4.22744 16.7851 5.47653 17.391 6.938C17.7931 7.90877 18.0001 8.94924 18 10H20ZM0 8V3C0 2.73478 0.105357 2.48043 0.292893 2.29289C0.48043 2.10536 0.734784 2 1 2H6C6.26522 2 6.51957 2.10536 6.70711 2.29289C6.89464 2.48043 7 2.73478 7 3V7C7 7.26522 6.89464 7.51957 6.70711 7.70711C6.51957 7.89464 6.26522 8 6 8H4C4 10.1217 4.84285 12.1566 6.34315 13.6569C7.84344 15.1571 9.87827 16 12 16V14C12 13.7348 12.1054 13.4804 12.2929 13.2929C12.4804 13.1054 12.7348 13 13 13H17C17.2652 13 17.5196 13.1054 17.7071 13.2929C17.8946 13.4804 18 13.7348 18 14V19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H12C5.373 20 0 14.627 0 8Z",
    fill: "url(#paint0_linear_108_562)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_108_562",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E80505"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone1);
export default __webpack_public_path__ + "static/media/phone1.01196ba6c9b53b32022b27da6521b782.svg";
export { ForwardRef as ReactComponent };